import { graphqlClient, urqlPlugin } from '@nitra/vite-boot/urql'
import '@quasar/extras/fontawesome-v6/fontawesome-v6.css'
import '@quasar/extras/material-icons/material-icons.css'
import { Notify, Quasar } from 'quasar'
import quasarLangUa from 'quasar/lang/uk'
import 'quasar/src/css/index.sass'
import 'src/css/app.scss'
import App from './App.vue'
import { pinia } from './njs/boot/pinia.js'
import { router } from './njs/boot/router.js'

const myApp = createApp(App)

myApp.use(pinia)

myApp.use(Quasar, {
  plugins: { Notify }, // import Quasar plugins and add here
  lang: quasarLangUa
  /*
  config: {
    brand: {
      // primary: '#e46262',
      // ... or all other brand colors
    },
    notify: {...}, // default set of options for Notify Quasar plugin
    loading: {...}, // default set of options for Loading Quasar plugin
    loadingBar: { ... }, // settings for LoadingBar Quasar plugin
    // ..and many more (check Installation card on each Quasar component/directive/plugin)
  }
  */
})

myApp.use(urqlPlugin, graphqlClient)

myApp.use(router)

// Assumes you have a <div id="app"></div> in your index.html
myApp.mount('#app')
